import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import styles from "@/styles/Price.module.scss";
import Link from "next/link";
import { useSubscriptionStatusQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FormatWatchPrice(_ref) {
  var _data$subscriptionSta;

  var price = _ref.price,
      type = _ref.type,
      ext = _ref.ext,
      isLoggedIn = _ref.isLoggedIn,
      discountPrice = _ref.discountPrice,
      discountFlag = _ref.discountFlag,
      course = _ref.course;

  var _useSubscriptionStatu = useSubscriptionStatusQuery({
    variables: {
      courseId: Number(course === null || course === void 0 ? void 0 : course.id)
    }
  }),
      data = _useSubscriptionStatu.data,
      loadingSubscriptionStatus = _useSubscriptionStatu.loading;

  if (isLoggedIn && loadingSubscriptionStatus) {
    return null;
  }

  var isTrialEnabled = isLoggedIn ? data === null || data === void 0 ? void 0 : (_data$subscriptionSta = data.subscriptionStatus) === null || _data$subscriptionSta === void 0 ? void 0 : _data$subscriptionSta.is_trial_enabled : true;
  var showDiscount = isLoggedIn && discountFlag;
  var showTrial = isTrialEnabled && (course === null || course === void 0 ? void 0 : course.trial_flag);

  if (type === "svod" && !showTrial && !showDiscount) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.watchPrice,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.watchPrices,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.priceLeft,
          children: "\u6708\u984D"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.priceRight,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.priceAmount,
            children: [formatPrice(price), "\u5186"]
          }), "\uFF08\u7A0E\u8FBC\uFF09", ext]
        })]
      })
    });
  } else if (type === "svod" && !showTrial && showDiscount) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.watchPrice,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.watchPrices,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.priceLeft,
          children: "\u6708\u984D"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.priceRight,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.priceAmount,
            children: [formatPrice(price), "\u5186"]
          }), "\uFF08\u7A0E\u8FBC\uFF09"]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.discountLink,
        children: /*#__PURE__*/_jsxs("p", {
          children: ["\u203B\u5BFE\u8C61\u306E\u30B9\u30AB\u30D1\u30FC\uFF01\u653E\u9001\u5546\u54C1\u3092\u3054\u8CFC\u5165\u306E\u5834\u5408\u3001\u5272\u5F15\u9069\u7528\u3068\u306A\u308B\u5546\u54C1\u3067\u3059\u3002\u5272\u5F15\u9069\u7528\u3068\u306A\u308B\u5546\u54C1\u306E\u7D44\u307F\u5408\u308F\u305B\u306F", /*#__PURE__*/_jsx(Link, {
            href: routes.campaignWithBroadcast,
            children: /*#__PURE__*/_jsx("a", {
              target: "_blank",
              rel: "noopener noreferrer",
              children: "\u3053\u3061\u3089"
            })
          }), "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044", /*#__PURE__*/_jsx("br", {}), "\u203B\u5BFE\u8C61\u306E\u653E\u9001\u5546\u54C1\u3092\u3054\u8CFC\u5165\u4E2D\u306E\u65B9\u306F\u6708\u984D", formatPrice(discountPrice), "\u5186(\u7A0E\u8FBC)", ext, " "]
        })
      })]
    });
  } else if (type === "svod" && showTrial && !showDiscount) {
    return /*#__PURE__*/_jsx("div", {
      className: "".concat(styles.watchPrice, " ").concat(styles.trialFlag),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.trialDurationArea,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.slate,
          children: /*#__PURE__*/_jsxs("span", {
            className: styles.bold,
            children: ["\u3010\u521D\u56DE\u8CFC\u5165\u9650\u5B9A\u3011", course.trialTermText]
          })
        }), /*#__PURE__*/_jsx("br", {}), course.trialText, "\u671F\u9593\u5F8C\u306F\u6708\u984D", /*#__PURE__*/_jsx("span", {
          className: styles.bold,
          children: formatPrice(price)
        }), "\u5186\uFF08\u7A0E\u8FBC\uFF09", ext, course.valuePlan && /*#__PURE__*/_jsxs("div", {
          children: [course.trialTermText, "\u306B\u3064\u3044\u3066\u306E\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
            href: routes.valuePlanCampaignDetail,
            children: /*#__PURE__*/_jsx("a", {
              target: "_blank",
              rel: "noopener noreferrer",
              children: "\u3053\u3061\u3089"
            })
          }), "\u304B\u3089\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"]
        })]
      })
    });
  } else if (type === "svod" && showTrial && showDiscount) {
    return /*#__PURE__*/_jsxs("div", {
      className: "".concat(styles.watchPrice, " ").concat(styles.trialFlag),
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.trialDurationArea,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.slate,
          children: /*#__PURE__*/_jsxs("span", {
            className: styles.bold,
            children: ["\u3010\u521D\u56DE\u8CFC\u5165\u9650\u5B9A\u3011", course.trialTermText]
          })
        }), /*#__PURE__*/_jsx("br", {}), course.trialText, "\u671F\u9593\u5F8C\u306F\u6708\u984D", /*#__PURE__*/_jsx("span", {
          className: styles.bold,
          children: formatPrice(price)
        }), "\u5186\uFF08\u7A0E\u8FBC\uFF09", ext, course.valuePlan && /*#__PURE__*/_jsxs("div", {
          children: [course.trialTermText, "\u306B\u3064\u3044\u3066\u306E\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
            href: routes.valuePlanCampaignDetail,
            children: /*#__PURE__*/_jsx("a", {
              target: "_blank",
              rel: "noopener noreferrer",
              children: "\u3053\u3061\u3089"
            })
          }), "\u304B\u3089\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.discountLink,
        children: /*#__PURE__*/_jsxs("p", {
          children: ["\u203B\u5BFE\u8C61\u306E\u30B9\u30AB\u30D1\u30FC\uFF01\u653E\u9001\u5546\u54C1\u3092\u3054\u8CFC\u5165\u306E\u5834\u5408\u3001\u5272\u5F15\u9069\u7528\u3068\u306A\u308B\u5546\u54C1\u3067\u3059\u3002\u5272\u5F15\u9069\u7528\u3068\u306A\u308B\u5546\u54C1\u306E\u7D44\u307F\u5408\u308F\u305B\u306F", /*#__PURE__*/_jsx(Link, {
            href: routes.campaignWithBroadcast,
            children: /*#__PURE__*/_jsx("a", {
              target: "_blank",
              rel: "noopener noreferrer",
              children: "\u3053\u3061\u3089"
            })
          }), "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u203B\u5BFE\u8C61\u306E\u653E\u9001\u5546\u54C1\u3092\u3054\u8CFC\u5165\u4E2D\u306E\u65B9\u306F\u6708\u984D", formatPrice(discountPrice), "\u5186(\u7A0E\u8FBC)", ext, " "]
        })
      })]
    });
  } else if (type === "tvod" && !showDiscount) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.watchPrice,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.watchPrices,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.priceLeft,
          children: "\u4FA1\u683C"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.priceRight,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.priceAmount,
            children: [formatPrice(price), "\u5186"]
          }), "\uFF08\u7A0E\u8FBC\uFF09", ext]
        })]
      })
    });
  } else if (type === "tvod" && showDiscount) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.watchPrice,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.watchPrices,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.priceLeft,
          children: "\u4FA1\u683C"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.priceRight,
          children: [/*#__PURE__*/_jsxs("span", {
            className: styles.priceAmount,
            children: [formatPrice(price), "\u5186"]
          }), "\uFF08\u7A0E\u8FBC\uFF09", /*#__PURE__*/_jsxs("span", {
            className: styles.discountLink,
            children: ["\u203B\u5BFE\u8C61\u306E\u30B9\u30AB\u30D1\u30FC\uFF01\u653E\u9001\u5546\u54C1\u3092\u3054\u8CFC\u5165\u306E\u5834\u5408\u3001\u5272\u5F15\u9069\u7528\u3068\u306A\u308B\u5546\u54C1\u3067\u3059\u3002\u5272\u5F15\u9069\u7528\u3068\u306A\u308B\u5546\u54C1\u306E\u7D44\u307F\u5408\u308F\u305B\u306F", /*#__PURE__*/_jsx(Link, {
              href: routes.campaignWithBroadcast,
              children: /*#__PURE__*/_jsx("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                children: "\u3053\u3061\u3089"
              })
            }), "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044", /*#__PURE__*/_jsx("br", {}), "\u203B\u5BFE\u8C61\u306E\u653E\u9001\u5546\u54C1\u3092\u3054\u8CFC\u5165\u4E2D\u306E\u65B9\u306F", formatPrice(discountPrice), "\u5186(\u7A0E\u8FBC)", ext]
          })]
        })]
      })
    });
  }
}